<template>
  <custom-dialog
    width="1400px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="tab-container">
        <custom-tab
          :list="tabData"
          v-model="tabIndex"
          :fixBorder="true"
        ></custom-tab>
        <div class="tab-content">
          <rework-items
            ref="reworkItems"
            :reworkList="reworkList"
            v-show="tabIndex === 'reworkItems'"
            @selection="onSelection"
            @replace="onReplace"
            @showImg="showPartImg"
            @filterChange="filterChange"
          ></rework-items>
          <replace-record
            ref="replaceRecord"
            :workOrderId="info.workOrderId"
            v-if="tabIndex === 'partReplaceRecord' && info.workOrderId"
            @showImg="showPartImg"
            @delReplaceRecord="onDelPartReplaceRecord"
            @addOtherPart="onAddOtherPart"
          ></replace-record>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        :disabled="!selectedReworkItemIds.length || isLoading"
        @click="onStore"
      >{{ $t('asm_start_rework_dialog.zan_cun') }}</el-button>
      <el-button
        :disabled="!selectedReworkItemIds.length"
        type="primary"
        @click="onFinish"
      >{{ $t('asm_start_rework_dialog.wan_cheng_fan_gong') }}</el-button>
    </div>
    <replace-parts-dialog
      v-if="replacePartVisible"
      @close="onReplacePartClose"
      :model="replacePartModel"
      @success="onReplaceSuccess"
    ></replace-parts-dialog>

    <part-img-dialog
      v-if="partImgVisible"
      @close="partImgVisible=false"
      :model="partImgModel"
      :bizId="partImgModel.data.orderPartId"
    ></part-img-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import reworkItems from './start_rework_dialog_rework_items.vue';
import replaceRecord from './start_rework_dialog_part_replace_record.vue';
import replacePartsDialog from './replace_parts_dialog.vue';
import partImgDialog from './part_img_dialog.vue';

/**
 * 备注：
 * 1 取消勾选返工项，需要调用取消勾选接口（即不需要保存，也会修改数据库）。然后还要删除对应的零件更换记录（调用阿康的接口）。
 */

// 查询ids1中，区别于ids2的第一个元素
function findDiffId(ids1, ids2) {
  return ids1.find(id1 => !ids2.includes(id1));
}

export default {
  mixins: [dialogMixins],
  components: {
    reworkItems,
    replaceRecord,
    replacePartsDialog,
    partImgDialog
  },
  data() {
    return {
      tabIndex: 'reworkItems',
      reworkList: [],
      // 取用workOrderItemId
      selectedReworkItemIds: [
      ],
      isLoading: false,
      replacePartVisible: false,
      replacePartModel: {},
      curAddId: '',
      isInitChecked: true,
      partImgVisible: false,
      partImgModel: {
        data: {}
      },
      formSearch: {},

    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('asm_start_rework_dialog.fan_gong_xiang'),
          value: 'reworkItems'
        },
        {
          name: this.$t('asm_start_rework_dialog.ljghjl'),
          value: 'partReplaceRecord'
        }
      ];
    },
    info() {
      const info = this.model.data;
      return info || {};
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    filterChange(e) {
      this.formSearch = Object.assign(this.formSearch, e);
      this.refresh();
    },
    onAddOtherPart(otherList) {
      const allRecord = [
        ...this.reworkList,
        ...otherList
      ];
      // 如果componentCode=other的，就不要拼在里面
      const excludeCodes = allRecord.filter(item => item.componentCode !== 'other' && item.componentCode).map(item => item.componentCode);
      this.showReplacePart(
        'fromReplaceOtherPart',
        this.info,
        '',
        excludeCodes.join(','),
        null
      );
    },
    showPartImg(row) {
      this.partImgModel = {
        title: this.$t('asm_start_rework_dialog.cha_kan_tu_pian'),
        data: row
      };
      this.partImgVisible = true;
    },
    // 重置checked, workOrderItemId非必填，但是如果有workOrderItemId，最好传入，否则row回去读取replacePartModel.reworkItem
    // 重置原因：用户勾选了checkbox，但是勾选后的接口操作不一定会成功，或者弹窗不一定提交
    async resetRowChecked(workOrderItemId) {
      const row = workOrderItemId ? this.getRowByWorkOrderItemId(workOrderItemId) : this.replacePartModel.reworkItem;
      if (row) {
        // 如果dialog关闭时，row没有orderPartId，说明该row没有创建更换记录，需要手动将checkbox close
        if (!row.orderPartId) {
          // this.$refs.reworkItems.unCheckRowById(row.workOrderItemId);
          await this.setCheckboxValue(row.workOrderItemId, false);

          // 更新选中的ids
          this.selectedReworkItemIds = this.selectedReworkItemIds.filter(id => id !== row.workOrderItemId);
        }
      }
    },
    onReplacePartClose() {
      this.replacePartVisible = false;
      this.resetRowChecked();
    },

    /**
     * @typedef {Object} DeviceInfo
     * @property {String} productCode
     * @property {String} bodyNum
     * @property {String} deviceId
     */
    /**
     * 显示更换零件dialog
     * @param {String} type fromRework : 从返工项列表中进入； fromReplaceOtherPart : 从更换其他零件记录中记录
     * @param {DeviceInfo} deviceInfo 设备信息
     * @param {String} defaultComponentCode 默认选中的更换位置
     * @param {String} excludeCodes 更换位置选项中，需要排除的选项，componentCode用逗号隔开
     * @param {Object} reworkItem 返工项
     */
    showReplacePart(type, deviceInfo, defaultComponentCode, excludeCodes = '', reworkItem) {
      this.replacePartModel = {
        type,
        data: deviceInfo,
        title: this.$t('asm_start_rework_dialog.geng_huan_ling_jian'),
        defaultComponentCode,
        excludeCodes,
        reworkItem
      };
      this.replacePartVisible = true;
    },
    // 判断是否需要更换零件
    shouldReplacePart(row) {
      return !!row.componentCode;
    },

    // 判断是否必填SN
    // 0不要sn 需要显示 partCount 1必须 2选填
    mustSn(row) {
      return `${row.needSn}` === '1';
    },

    // 判断是否选填SN
    // 0不要sn 需要显示 partCount 1必须 2选填
    optionalSn(row) {
      return `${row.needSn}` === '2';
    },


    // 暂存
    // 暂存不支持空勾选。
    async onStore() {
      try {
        const info = this.model.data;
        const { workOrderId } = info;
        const reqData = this.selectedReworkItemIds;
        const reqUrl = `${apis.workOrderItemTemporarilySave}/${workOrderId}`;

        this.isLoading = true;
        await this.$postJSON(reqUrl, reqData, true);
        this.isLoading = false;

        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });

        this.$emit('store', reqData);

        this.closeDialog();

      } catch (e) {
        this.isLoading = false;
      }
    },

    async init() {
      await this.getReworkList();
      this.initChecked();
    },
    // 在对返工项进行更换零件操作后，需要更新row的数据
    async updateRow(row) {
      const newList = await this.getReworkListData();
      const newRow = newList.find(item => item.workOrderItemId === row.workOrderItemId);
      this.updateRowData(newRow, row);
    },

    // 更新target的字段值，数据来源：source
    updateRowData(source, target) {
      const propeties = ['newPartCount', 'orderPartId', 'partSn', 'newPartSn'];
      propeties.forEach((key) => {
        this.$set(target, key, source[key]);
      });
    },
    async refresh() {
      this.isInitChecked = true;
      await this.getReworkList();
      await this.initChecked();
    },
    // 初始化返工列表的勾选
    initChecked() {
      return new Promise((resolve) => {
        const checkedItemIds = this.reworkList.filter(item => item.isChecked).map(item => item.workOrderItemId);
        this.selectedReworkItemIds = checkedItemIds;
        setTimeout(() => {
          this.$refs.reworkItems.selectRowsByItemIds(
            this.selectedReworkItemIds
          );
          setTimeout(() => {
            this.isInitChecked = false;
            resolve();
          }, 300);
        }, 300);
      });

    },
    closeDialog() {
      this.visible = false;
    },

    async onReplaceSuccess(orderPartId) {
      const type = this.replacePartModel.type;
      const row = this.replacePartModel.reworkItem;
      if (row) {
        row.orderPartId = orderPartId;
      }
      if (type === 'fromRework') {
        // 如果返工项的更换零件，则直接更换row的字段值
        await this.updateRow(row);
        // =>
        // 刷新
        // this.refresh();
      } else {
        // 如果是零件更换记录中的：更换其他零件记录，则列表刷新
        this.$refs.replaceRecord.getOtherReplaceRecord();
      }
      this.replacePartVisible = false;
    },

    getRowByWorkOrderItemId(id) {
      const row = this.reworkList.find(item => item.workOrderItemId === id);
      return row;
    },

    onReplace(row) {
      this.showReplacePart(
        'fromRework',
        this.info,
        row.componentCode,
        '',
        row
      );
    },

    async handleAddSelection(addId) {
      this.curAddId = addId;
      /**
     * 1.若勾选的的返工项，需要更换零件且 零件SN为必填，则勾选后弹出 更换零件页面，
     * 零件更换页面需默认加载需更换零件的位置旧零件信息 与新的零件编号信息（与旧零件一致），只需录入零件SN

2.若勾选的返工项 选填SN，则无需弹出零件更换页面，但是需创建一条零件更换记录，零件数量为1  可更换零件

3.若勾选的返工项零件数量为1，则无需弹出零件更换页面，但是需创建一条零件更换记录，零件数量为1

4..若勾选的返工项零件数量大于1，则需弹出零件更换 页面，零件更换页面需默认加载需更换零件的位置旧零件信息 与新的零件编号信息（与旧零件一致），只需录入返工零件数量。 返工数量不能大于零件数量
     */
      const row = this.getRowByWorkOrderItemId(addId);

      // 是否需要更换零件
      const isNeedReplacePart = this.shouldReplacePart(row);

      // 是否必填SN
      const isNeedSn = this.mustSn(row);

      // 选填SN
      const optionalSn = this.optionalSn(row);

      // 如果没有componentCode说明零件信息，无需进一步操作
      if (!row.componentCode) {
        return;
      }


      // 1和4
      if (isNeedReplacePart && isNeedSn || row.partCount > 1) {


        this.showReplacePart(
          'fromRework',
          this.info,
          row.componentCode,
          '',
          row
        );
        return;
      }

      // 2 和 3
      if (optionalSn || row.partCount === 1) {
        await this.createRowRecord(row);
      }


    },

    async delPartRecord(orderPartId) {
      const reqUrl = `${apis.workOrderPartDelete}/${orderPartId}`;
      return this.$postJSON(reqUrl);
    },

    async createRowRecord(row) {
      try {
        const deviceInfo = this.info;
        const bodyNum = deviceInfo.bodyNum;
        const componentCode = row.componentCode;
        const langComponentName = row.langComponentName;

        // 获取旧零件信息
        const oldPartInfoRes = await this.$getJSON(`${apis.stockOldPartInfo}`, {
          bodyNum,
          componentCode,
        });

        const oldPartInfo = oldPartInfoRes.data;

        const reqData = {
          langComponentName,
          oldNewPartSn: oldPartInfo.partSn,
          componentCode: componentCode,
          oldPartCode: oldPartInfo.partCode || row.partCode,
          oldPartSn: oldPartInfo.partSn,
          orderDeviceId: deviceInfo.orderDeviceId,
          orderPartId: row.orderPartId,
          orderTechnicianId: deviceInfo.orderTechnicianId,
          partCode: row.partCode,
          partSn: '',
          replaceDesc: '',
          replaceNum: 1,
          workOrderId: deviceInfo.workOrderId,
          // 工单服务项ID，返工单时必填
          workOrderItemId: row.workOrderItemId,
        };

        // 创建零件更换记录
        await this.$postJSON(apis.workOrderPartPartReplace, reqData, true);

        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });

        // this.$set(row, 'orderPartId', res.data);
        this.updateRow(row);
        // await this.refresh();
      } catch (e) {
        // await this.refresh();
        // 如果无法创建记录，则重置checkbox状态
        this.resetRowChecked(row.workOrderItemId);
      }


    },

    async handleDelSelection(delId) {
      const delReworkItemUrl = `${apis.workOrderItemClearCheck}/${delId}`;
      const row = this.getRowByWorkOrderItemId(delId);

      // (1) 调用返工项的 - 取消勾选接口
      await this.$postJSON(delReworkItemUrl);

      await this.updateRow(row);

      // await this.refresh();
    },

    // 设置checkbox的勾选，但是不触发selection
    async setCheckboxValue(workOrderItemId, value) {
      this.isInitChecked = true;

      this.$refs.reworkItems.checkRowById(workOrderItemId, value);
      // table的勾选会触发selection事件,而该事件回调是异步触发，所以现在需要一个时间间隔,用isInitChecked来避免selection的执行
      await this.timeOut(17);
      this.isInitChecked = false;
    },

    async timeOut(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },

    // 处理 返工零件更换记录的删除
    async onDelPartReplaceRecord(row) {
      // 设置返工项的勾选为false
      await this.setCheckboxValue(row.workOrderItemId, false);

      const selectedReworkItemIds = [...this.selectedReworkItemIds].filter(id => id !== row.workOrderItemId);

      await this.onSelection(selectedReworkItemIds);

      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success',
      });

      // 更新返工零件更换记录
      this.$refs.replaceRecord.getReworkPartReplaceRecord();
    },

    async onSelection(itemIds) {
      if (this.isInitChecked) {
        return;
      }

      this.$showLoading();

      try {
        const oldItemIds = [...this.selectedReworkItemIds];
        const newItemIds = [...itemIds];
        this.selectedReworkItemIds = itemIds;

        const diff = newItemIds.length - oldItemIds.length;
        if (diff === 1) {
          this.$closeLoading();
          // 代表新增
          const addId = findDiffId(newItemIds, oldItemIds);
          await this.handleAddSelection(addId);
        }
        if (diff === -1) {
          // 代表删除
          const delId = findDiffId(oldItemIds, newItemIds);
          await this.handleDelSelection(delId);
        }
      } catch (e) {
        //
      }

      this.$closeLoading();
    },
    async getReworkListData() {
      const info = this.model.data;
      const { workOrderId } = info;
      const url = `${apis.workOrderItemReworkList}/${workOrderId}`;

      return this.$getJSON(url, this.formSearch).then(res => res.data);
    },
    // 获取返工项列表
    async getReworkList() {
      this.reworkList = await this.getReworkListData();
    },

    async validate() {

      // 比返项：isRequired
      // 返工数量：newPartCount
      // 零件数量： partCount
      const reworkList = this.reworkList.filter(item => !item.isInvalid && item.componentCode); // 过滤无效项
      const selectedReworkItemIds = this.selectedReworkItemIds;

      // 需校验所必返项目有无选择，若无则提示“有必反项未返工”。
      const requiredList = reworkList.filter(item => item.isRequired);
      // 当必返项存在没有被勾选时为true
      const requireItemNotInSelectedList = requiredList.some(item => !selectedReworkItemIds.includes(item.workOrderItemId));
      if (requireItemNotInSelectedList) {
        this.$message({
          message: this.$t('asm_start_rework_dialog.ybfxwfg'),
          type: 'error',
        });
        return Promise.reject();
      }

      // 需校验必反项目 返工数量是否 与零件数量一致，若不一致 则提示“必反项 返工零件数量有误”
      const requiredItemPartNumErr = requiredList.some(item => item.newPartCount !== item.partCount);
      if (requiredItemPartNumErr) {
        this.$message({
          message: this.$t('asm_start_rework_dialog.bfxfgljslyw'),
          type: 'error',
        });
        return Promise.reject();
      }


      return Promise.resolve();
    },

    async onFinish() {
      const selectedReworkItemIds = this.selectedReworkItemIds;

      // 校验勾选和零件数量
      await this.validate();

      const reqUrl = `${apis.workOrderItemFinishRework}/${this.info.workOrderId}`;
      await this.$postJSON(reqUrl, selectedReworkItemIds, true);

      this.$message({
        message: this.$t('Common.com_handle_success'),
        type: 'success',
      });

      this.$emit('success');

      this.closeDialog();

    }
  },
};
</script>

<style lang="scss"></style>
